import { useContext } from 'react';
import { SiloRealFormContext } from './form-context';

export function useSiloRealFormContext() {
  const context = useContext(SiloRealFormContext);
  if (!context) throw new Error('useSiloRealFormContext must be used within a SiloRealFormProvider');
  return context;
}
